<template>
  <div class="p-3">
    <PageHeading headerTitle=""/>
    <b-button
      v-if="$i18n.locale=='en'"
      @click="window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual.pdf`)"
      >User Manual</b-button
      >
      <!-- href="/bd/ess/BD_ESH_Application_User_Manual.pdf"
      download="BD_ESH_Application_User_Manual.pdf" -->
    <b-button 
      v-else-if="$i18n.locale=='zh_hk'"
      class="float-right bd-button"
      @click="window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual_hk.pdf`)"
      >用戶手冊</b-button
      >
      <!-- href="/bd/ess/BD_ESH_Application_User_Manual_hk.pdf"
      download="BD_ESH_Application_User_Manual_hk.pdf" -->
    <b-button 
      v-else-if="$i18n.locale=='zh_cn'"
      class="float-right bd-button"
      @click="window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual_cn.pdf`)"
      >用户手册</b-button
      >
      <!-- href="/bd/ess/BD_ESH_Application_User_Manual_cn.pdf"
      download="BD_ESH_Application_User_Manual_cn.pdf" -->

    <h2>{{ description }}</h2>

    <div v-dompurify-html="content"></div>

    <BButtonToolbar>
      <BButton class="bd-button mr-2" v-if="$i18n.locale=='en'" @click="print">{{$t('print')}}</BButton>
      <BButton class="mr-2" variant="danger" @click="close">
        {{$t('commonLang.general.close')}}
      </BButton>
      <b-button
        v-if="$i18n.locale=='en'"
        @click="window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual.pdf`)"
        >User Manual</b-button
        >
        <!-- href="/bd/ess/BD_ESH_Application_User_Manual.pdf"
        download="BD_ESH_Application_User_Manual.pdf" -->
      <b-button 
        v-else-if="$i18n.locale=='zh_hk'"
        class="bd-button"
        @click="window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual_hk.pdf`)"
        >用戶手冊</b-button
        >
        <!-- href="/bd/ess/BD_ESH_Application_User_Manual_hk.pdf"
        download="BD_ESH_Application_User_Manual_hk.pdf" -->
      <b-button 
        v-else-if="$i18n.locale=='zh_cn'"
        class="bd-button"
        @click="window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual_cn.pdf`)"
        >用户手册</b-button
        >
        <!-- href="/bd/ess/BD_ESH_Application_User_Manual_cn.pdf"
        download="BD_ESH_Application_User_Manual_cn.pdf" -->
    </BButtonToolbar>
  </div>
</template>

<script >
import { VHelpProViewer } from '@unify/v-help-pro';
import Vue from 'vue';
import PageHeading from '@/components/PageHeading';

export default Vue.extend({
  extends: VHelpProViewer,
  components: {
    PageHeading
  }
});
</script>

<i18n src="@/locales/actions.locale"></i18n>